import * as Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import * as React from 'react';
// import { SESSION_STORAGE_AVAILABILITY_FILTER } from '../core/index';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ColapsePanel } from '../core/ColapsePanel';
import { HotelBedData } from '../shared/index';
import { Distinct } from '../utils/distinct-array';
import { getAjaxhelper, isNull } from '../utils/index';
import { CheckBox, HotelsLeftSidePanel } from './HotelsLeftSidePanel';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const Handle = Slider.Handle;

const handle = (props: any) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
        >
            <Handle value={value} {...restProps} />
        </Tooltip>
    );
};
export interface FilterDataReturn {
    hotelCodes: number[];
    description: string;
    icon?: string;
    simpleCode?: string;
    accommodationType?: string;
}
export interface GlobalDataFilter {
    DestinationZone: FilterDataReturn[];
    hotelName: FilterDataReturn[];
    AccomodationType: FilterDataReturn[];
    Category: FilterDataReturn[];
    HotelBoard: FilterDataReturn[];
    Facilities: FilterDataReturn[];
    Special: FilterDataReturn[];
    Segment: FilterDataReturn[];
    Interest: FilterDataReturn[];
    PriceRage: FilterDataReturn[];
}

export interface GlobalDataFilterState {
    DestinationZone: CheckBox[];
    hotelName: CheckBox[];
    AccomodationType: CheckBox[];
    Category: CheckBox[];
    HotelBoard: CheckBox[];
    Facilities: CheckBox[];
    Special: CheckBox[];
    Segment: CheckBox[];
    Interest: CheckBox[];
    PriceRage: CheckBox[];
}

export interface HotelsLeftSideProps extends BaseComponentProps {
    lang: string;
    // page: number;
    count: number;
    currency: string;
    getHotels: (hotelCodes: number[] | any, externalFilter: HotelBedData.ExternalFilter) => any;
    // externalFilter: HotelBedData.ExternalFilter;
    responKey: string;

    updateMinMax: (min: number, max: number) => any;

    globalDataFilter: (dataFilter: GlobalDataFilter) => any;
    // maxRate: number;
    // minRate: number;
}
export interface HotelsLeftSideState extends BaseComponentState {
    filters: GlobalDataFilter;
    checkbox: GlobalDataFilterState;
    select: GlobalDataFilterState;
    hotelCodes: number[];
    hotelCodesInDestinations: number[];
    maxRate: number;
    minRate: number;
    externalFilter: {
        maxRate: number;
        minRate: number;
    };
    versi: number;
}

export interface GetChecboxMethod {
    (val: string): void;
}
export class HotelsLeftSide extends BaseComponent<HotelsLeftSideProps, HotelsLeftSideState> {
    constructor(props: HotelsLeftSideProps) {
        super(props);
        this.state = {
            versi: 0,
            filters: {
                DestinationZone: [],
                hotelName: [],
                AccomodationType: [],
                Category: [],
                HotelBoard: [],
                Facilities: [],
                Special: [],
                Segment: [],
                Interest: [],
                PriceRage: []
            },
            checkbox: {
                DestinationZone: [],
                hotelName: [],
                AccomodationType: [],
                Category: [],
                HotelBoard: [],
                Facilities: [],
                Special: [],
                Segment: [],
                Interest: [],
                PriceRage: []
            },
            select: {
                DestinationZone: [],
                hotelName: [],
                AccomodationType: [],
                Category: [],
                HotelBoard: [],
                Facilities: [],
                Special: [],
                Segment: [],
                Interest: [],
                PriceRage: []
            },
            hotelCodes: [],
            hotelCodesInDestinations: [],
            maxRate: 0, // this.props.maxRate,
            minRate: 0, // this.props.minRate,
            externalFilter: {
                maxRate: 0, // this.props.maxRate,
                minRate: 0 // this.props.minRate
            }
        };
    }

    componentDidMount() {
        this.getData();
    }
    componentDidUpdate(prevProps: HotelsLeftSideProps, prevState: HotelsLeftSideState) {
        if (prevProps.responKey !== this.props.responKey || prevProps.lang !== this.props.lang) {
            this.getData();
        }
        /*
                if (prevProps.maxRate !== this.props.maxRate || prevProps.minRate !== this.props.minRate) {
                    this.rageRate();
                }
        */
    }

    /*
    rageRate = () => {
        this.setStateHelper(
            st => {
                st.maxRate = this.props.maxRate / 1;
                st.minRate = this.props.minRate / 1;
                st.externalFilter = {
                    maxRate: this.props.maxRate / 1,
                    minRate: this.props.minRate / 1
                };
                st.versi += 1;
                // console.log("max rate, min rate", st.maxRate, st.minRate, st.versi + 1);
            });
    }
*/
    getData() {
        getAjaxhelper().post('/dynamics/hb-api/hotels-filter', {
            "reqKey": this.props.responKey,
            "lang": this.props.lang,
            "cur": this.props.currency
        }).then((d: any) => {
            this.setStateHelper(
                st => {
                    st.filters = d;
                    st.versi += 1;
                    let min = !isNull(d.minMax.min) ? d.minMax.min : 0;
                    let max = !isNull(d.minMax.max) ? d.minMax.max : 0;
                    st.maxRate = max;
                    st.minRate = min;
                    st.externalFilter = {
                        minRate: min,
                        maxRate: max
                    };
                    // console.log("max rate, min rate", st.maxRate, st.minRate, st.versi + 1);
                },
                () => {
                    this.props.globalDataFilter(this.state.filters);
                    this.props.updateMinMax(this.state.minRate, this.state.maxRate);
                    this.updateSelectItem();
                });
        }).catch((exc) => { console.error('error: ', exc); });
    }

    updateSelectItemList(datas: FilterDataReturn[], checkCount: number) {
        let retval: {
            checkbox: CheckBox[],
            select: CheckBox[]
        } = {
            checkbox: [], select: []
        };
        let desCheckbox: CheckBox[] = [];
        let desSelec: CheckBox[] = [];
        let i: number = 0;
        for (let a of datas) {
            if (i < checkCount) {
                desCheckbox.push({
                    code: JSON.stringify(a),
                    value: a.description = a.description,
                    checked: false
                });

                i++;
            } else {
                desSelec.push({
                    code: JSON.stringify(a),
                    value: a.description = a.description,
                    checked: false
                });
            }
        }
        retval.checkbox = desCheckbox;
        retval.select = desSelec;
        return retval;
    }

    updateSelectItem() {
        this.setStateHelper((st: HotelsLeftSideState) => {
            // let hc = st.hotelCodes;
            let pricer = this.updateSelectItemList(st.filters.PriceRage, 10);
            st.checkbox.PriceRage = pricer.checkbox;
            st.select.PriceRage = pricer.select;

            let desc = this.updateSelectItemList(st.filters.DestinationZone, 10);
            st.checkbox.DestinationZone = desc.checkbox;
            st.select.DestinationZone = desc.select;

            let hm = this.updateSelectItemList(st.filters.hotelName, 0);
            st.checkbox.hotelName = hm.checkbox;
            st.select.hotelName = hm.select;

            let ac = this.updateSelectItemList(st.filters.AccomodationType, 10);
            st.checkbox.AccomodationType = ac.checkbox;
            st.select.AccomodationType = ac.select;

            let cat = this.updateSelectItemList(st.filters.Category, 10);
            st.checkbox.Category = cat.checkbox;
            st.select.Category = cat.select;

            let hb = this.updateSelectItemList(st.filters.HotelBoard, 10);
            st.checkbox.HotelBoard = hb.checkbox;
            st.select.HotelBoard = hb.select;

            let hf = this.updateSelectItemList(st.filters.Facilities, 10);
            st.checkbox.Facilities = hf.checkbox;
            st.select.Facilities = hf.select;

            let sp = this.updateSelectItemList(st.filters.Special, 10);
            st.checkbox.Special = sp.checkbox;
            st.select.Special = sp.select;

            let sg = this.updateSelectItemList(st.filters.Segment, 10);
            st.checkbox.Segment = sg.checkbox;
            st.select.Segment = sg.select;

            let int = this.updateSelectItemList(st.filters.Interest, 10);
            st.checkbox.Interest = int.checkbox;
            st.select.Interest = int.select;

            st.versi += 1;

            // console.log("max rate, min rate", st.maxRate, st.minRate, st.versi + 1);
        });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let colapsePanel = <span />;

        let handleChange = (value: any) => {
            this.setStateHelper(
                st => {
                    st.externalFilter = { minRate: value[0], maxRate: value[1] };
                    st.versi += 1;
                },
                () => this.props.getHotels(this.state.hotelCodes, this.state.externalFilter));
        };

        let trigerMin: (evt: any) => any = (evt: any) => {
            let val: any = evt.target.value;
            if (val / 1 !== this.state.externalFilter.minRate / 1) {
                this.setStateHelper(
                    st => {
                        st.externalFilter.minRate = val as any / 1;
                        // console.log("max rate, min rate", st.maxRate, st.minRate, st.versi + 1);
                    },
                    () => {
                        handleChange([val, this.state.externalFilter.maxRate]);
                    }
                );
            } else {
                console.log("max rate, min rate", this.state.maxRate, this.state.minRate, this.state.versi + 1);
            }
        };
        let trigetMax: (evt: any) => any = (evt: any) => {
            let val: any = evt.target.value;
            if (val / 1 !== this.state.externalFilter.maxRate / 1) {
                this.setStateHelper(
                    st => {
                        st.externalFilter.maxRate = val as any / 1;
                        // console.log("max rate, min rate", st.maxRate, st.minRate, st.versi + 1);
                    },
                    () => {
                        handleChange([this.state.externalFilter.minRate, val]);
                    }
                );
            } else {
                console.log("max rate, min rate", this.state.maxRate, this.state.minRate, this.state.versi + 1);
            }
        };

        // colapsePanel = <DynamicBounds />;

        colapsePanel = (
            <div>
                <div className="col-md-6">
                    Min : <input
                        key={`min-${this.state.versi}`}
                        type='number'
                        className="form-control"
                        defaultValue={this.state.externalFilter.minRate && !isNaN(this.state.externalFilter.minRate) ? this.state.externalFilter.minRate + '' : '0'}
                        onBlur={trigerMin}
                        onKeyDown={
                            evt => {
                                // console.log(evt.keyCode);
                                if (evt.keyCode === 13) {
                                    trigerMin(evt);
                                }
                            }
                        }
                    />
                </div>
                <div className="col-md-6" >
                    Max : <input
                        key={`max-${this.state.versi}`}
                        type='number'
                        className="form-control"
                        defaultValue={this.state.externalFilter.maxRate && !isNaN(this.state.externalFilter.maxRate) ? this.state.externalFilter.maxRate + '' : '0'}
                        onBlur={trigetMax}
                        onKeyDown={
                            evt => {
                                if (evt.keyCode === 13) {
                                    trigetMax(evt);
                                }
                            }
                        }
                    />
                </div>
                <div className="col-md-12" style={{ padding: '20px 0' }} key={`rage-${this.state.versi}`}>
                    <Range
                        step={1}
                        allowCross={false}
                        min={isNull(this.state.minRate) ? 0 : this.state.minRate - 1}
                        max={isNull(this.state.maxRate) ? 100 : this.state.maxRate + 1}
                        tipFormatter={(value: any) => `${value}`}
                        handle={handle}
                        defaultValue={[isNull(this.state.externalFilter.minRate) ? 0 : this.state.externalFilter.minRate - 1, isNull(this.state.externalFilter.maxRate) ? 100 : this.state.externalFilter.maxRate + 1]}
                        onAfterChange={handleChange}
                    />
                </div>
            </div>
        );

        return (
            <div className='col-md-3 col-md-pull-9' key={'leftsidefilter'} >
                <button
                    style={{ marginBottom: 15 }}
                    onClick={
                        () => {
                            this.props.getHotels(null, {});
                            // sessionStorage.removeItem(SESSION_STORAGE_AVAILABILITY_FILTER);
                        }
                    }
                    className="btn btn-primary btn-block"
                >
                    Clear All Filters
                </button>

                <a href={`/maps?rk=${this.props.responKey}`} target="_blank" >
                    <img src="https://storage.googleapis.com/bali-hotel-images/IMG_0392-713x420.jpg" width="100%" style={{ marginBottom: 20 }} />
                </a>

                <HotelsLeftSidePanel
                    title='Destinations'
                    checkbox={this.state.checkbox.DestinationZone}
                    selectItems={this.state.select.DestinationZone}
                    selectedItem={this.selectedItem('DestinationZone')}
                    versi={this.state.versi}
                    key='1'
                />
                <HotelsLeftSidePanel
                    title='Budget Per Night'
                    checkbox={this.state.checkbox.PriceRage}
                    selectItems={this.state.select.PriceRage}
                    selectedItem={this.selectedItem('PriceRage')}
                    versi={this.state.versi}
                    key='31'
                />
                <ColapsePanel
                    title="Price Per Room"
                    colapse={true}
                    component={colapsePanel}
                />

                <HotelsLeftSidePanel
                    title='Hotel Name'
                    checkbox={this.state.checkbox.hotelName}
                    selectItems={this.state.select.hotelName}
                    selectedItem={this.selectedItem('hotelName')}
                    versi={this.state.versi}
                    selectType="hotelName"
                    key='2'
                />
                <HotelsLeftSidePanel
                    title='Accommodation Type'
                    checkbox={this.state.checkbox.AccomodationType}
                    selectItems={this.state.select.AccomodationType}
                    selectedItem={this.selectedItem('AccomodationType')}
                    versi={this.state.versi}
                    key='3'
                />
                <HotelsLeftSidePanel
                    title='Categories'
                    checkbox={this.state.checkbox.Category}
                    selectItems={this.state.select.Category}
                    selectedItem={this.selectedItem('Category')}
                    versi={this.state.versi}
                    key='4'
                />
                {
                    /*
                    <HotelsLeftSidePanel
                                        title='Hotel Boards'
                                        checkbox={this.state.checkbox.HotelBoard}
                                        selectItems={this.state.select.HotelBoard}
                                        selectedItem={this.selectedItem('HotelBoard')}
                                        versi={this.state.versi}
                                        key='5'
                                    />
                    */

                }

                <HotelsLeftSidePanel
                    title='Hotel Facilities'
                    checkbox={this.state.checkbox.Facilities}
                    selectItems={this.state.select.Facilities}
                    selectedItem={this.selectedItem('Facilities')}
                    versi={this.state.versi}
                    key='6'
                />
                <HotelsLeftSidePanel
                    title='Offers'
                    checkbox={this.state.checkbox.Special}
                    selectItems={this.state.select.Special}
                    selectedItem={this.selectedItem('Special')}
                    versi={this.state.versi}
                    key='7'
                />
                <HotelsLeftSidePanel
                    title='Type Of Hotel'
                    checkbox={this.state.checkbox.Segment}
                    selectItems={this.state.select.Segment}
                    selectedItem={this.selectedItem('Segment')}
                    versi={this.state.versi}
                    key='8'
                />
                <HotelsLeftSidePanel
                    title='Point of Interest'
                    checkbox={this.state.checkbox.Interest}
                    selectItems={this.state.select.Interest}
                    selectedItem={this.selectedItem('Interest')}
                    versi={this.state.versi}
                    key='9'
                /> 

            </div>
        );
    }

    carculateHotelCodes = () => {
        let hotelCodes: number[] = [];
        this.setStateHelper(
            (st: HotelsLeftSideState) => {
                hotelCodes = this.ambilHotelCodes(st.checkbox.DestinationZone, hotelCodes);
                st.hotelCodesInDestinations = hotelCodes;
                let hmSelectedCodes: number[] = [];
                for (let k of this.state.checkbox.hotelName) {
                    let c = k.checked;
                    if (c) {
                        for (let l of JSON.parse(k.code).hotelCodes) {
                            hmSelectedCodes.push(l);
                        }
                    }
                }
                hotelCodes = this.ambilHotelCodes(st.checkbox.hotelName, hotelCodes).concat(hmSelectedCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.PriceRage, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.AccomodationType, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.Category, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.HotelBoard, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.Facilities, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.Special, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.Segment, hotelCodes);
                hotelCodes = this.ambilHotelCodes(st.checkbox.Interest, hotelCodes);
                let hcc: any = Distinct(hotelCodes);
                st.hotelCodes = hcc;
                this.updateSelectedItemWorker(st);
            },
            () => {
                this.props.getHotels(this.state.hotelCodes, this.state.externalFilter);
            }
        );
    }
    /*
        carculateHotelCodesNew = (st: HotelsLeftSideState) => {
            let hotelCodes: number[] = [];
            hotelCodes = this.ambilHotelCodes(st.checkbox.DestinationZone, hotelCodes);
            st.hotelCodesInDestinations = hotelCodes;
            let hmSelectedCodes: number[] = [];
            for (let k of this.state.checkbox.hotelName) {
                let c = k.checked;
                if (c) {
                    for (let l of JSON.parse(k.code).hotelCodes) {
                        hmSelectedCodes.push(l);
                    }
                }
            }
            hotelCodes = this.ambilHotelCodes(st.checkbox.hotelName, hotelCodes).concat(hmSelectedCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.AccomodationType, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.Category, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.HotelBoard, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.Facilities, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.Special, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.Segment, hotelCodes);
            hotelCodes = this.ambilHotelCodes(st.checkbox.Interest, hotelCodes);
            let hcc: any = Distinct(hotelCodes);
            st.hotelCodes = hcc;
            this.updateSelectedItemWorker(st);
        }
    */
    createNewFilter(datas: FilterDataReturn[], hc: number[], count: number) {
        let tmpAccSelect: CheckBox[] = [];
        let checkbox: CheckBox[] = [];
        let select: CheckBox[] = [];
        let i = 0;
        for (let a of datas) {
            for (let x of hc) {
                if (a.hotelCodes.indexOf(x) > -1) {
                    tmpAccSelect.push({
                        code: JSON.stringify(a),
                        value: a.description,
                        checked: false
                    });
                }
            }
        }
        let ts: any = Distinct(tmpAccSelect);
        tmpAccSelect = ts;
        i = 0;
        for (let a of tmpAccSelect) {
            if (i < count) {
                checkbox.push(a);
                i++;
            } else {
                select.push(a);
            }
        }
        return {
            checkbox: checkbox, select: select
        };
    }

    updateSelectedItemWorker: (st: HotelsLeftSideState) => void = (st: HotelsLeftSideState) => {
        // let hc = st.hotelCodes;
        let hcd = st.hotelCodesInDestinations;
        // Calculate Hotel Name Search
        let hmSelectedCodes: number[] = [];
        for (let k of this.state.checkbox.hotelName) {
            hmSelectedCodes.concat(JSON.parse(k.code).hotelCodes);
        }

        let hmSelec: CheckBox[] = [];
        for (let a of st.filters.hotelName) {
            if (hcd.length === 0) {
                hmSelec.push({
                    code: JSON.stringify(a),
                    value: a.description,
                    checked: false
                });
            } else {
                for (let j of a.hotelCodes) {
                    if (hcd.indexOf(j) > -1) {
                        if (hmSelectedCodes.length === 0) {
                            hmSelec.push({
                                code: JSON.stringify(a),
                                value: a.description,
                                checked: false
                            });
                        } else if (hmSelectedCodes.indexOf(j) < 0) {
                            hmSelec.push({
                                code: JSON.stringify(a),
                                value: a.description,
                                checked: false
                            });
                        }
                        break;
                    }
                }
            }
        }
        st.select.hotelName = hmSelec;
    }

    ambilHotelCodes(st: any[], ret: number[]) {
        let a: number[] = [];
        for (let b of st) {
            if (b.checked) {
                let m = JSON.parse(b.code);
                a = a.concat(m.hotelCodes);
            }
        }
        let a2: any = Distinct(a);
        a = a2;
        return this.bandingkanArray(ret, a);
    }

    bandingkanArray(arr1: number[], arr2: number[]) {
        let arr3 = [];
        if (arr1.length === 0) {
            return arr2;
        }
        if (arr2.length === 0) {
            return arr1;
        }
        for (let a of arr2) {
            if (arr1.indexOf(a) > -1) {
                arr3.push(a);
            }
        }
        return arr3;

    }

    selectedItem: (key: 'PriceRage' | 'DestinationZone' | 'hotelName' | 'AccomodationType' | 'Category' | 'HotelBoard' | 'Facilities' | 'Special' | 'Segment' | 'Interest') => GetChecboxMethod = (key: any) => {
        return (val: string) => {
            this.setStateHelper(
                (st: HotelsLeftSideState) => {
                    let i = 0;
                    let itemsSelect: any[] = (st.select as any)[key];
                    let itemsChackbox: any[] = (st.checkbox as any)[key];
                    for (let a of itemsSelect) {
                        if (a.code === val) {
                            let singado: boolean = true;
                            for (let chk of itemsChackbox) {
                                if (chk.code === val) {
                                    singado = false;
                                    break;
                                }
                            }
                            if (singado) {
                                itemsChackbox.push({
                                    code: a.code,
                                    value: a.value,
                                    checked: true
                                });
                                itemsSelect.splice(i, 1);
                                st.versi++;
                                // this.carculateHotelCodesNew(st);
                                return;
                            }
                        }
                        i++;
                    }
                    // let haveMatchChk: boolean = false ;
                    let j = 0;
                    for (let a of itemsChackbox) {

                        if (a.code === val) {
                            //  haveMatchChk = true  ;
                            if (a.checked === true) {
                                a.checked = false;
                                if (key === "hotelName") {
                                    itemsChackbox.slice(j, 1);
                                }
                            } else {
                                a.checked = true;
                            }
                            // this.carculateHotelCodesNew(st);
                            return;
                        }
                        j++;
                    }

                },
                /*() => {
                    this.props.getHotels(this.state.hotelCodes, this.state.externalFilter);
                }*/
                this.carculateHotelCodes
            );
        };
    }
}



// WEBPACK FOOTER //
// ./src/hotels/HotelsLeftSide.tsx